import React, { useState } from "react";
import { useEffect } from "react";

import { ToastContainer } from "react-toastify";

import { Elements } from "@stripe/react-stripe-js";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import RootRouter from "./routes/index";
import {
  loadScriptByURL,
  richSnippetImplementation,
} from "./components/helpers/utils";
import {
  GOOGLE_API_KEY,
  shouldLoadGoogleMapsScript,
  stripePromise,
} from "./components/helpers/constants";

import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import { Loader } from "./components/common/loader";
import useGoogleMapsScript from "./components/hooks/useGoogleMapScript";
import { useDispatch } from "react-redux";
import { autocompleteAction } from "./redux/slices/google-map-api/autocompleteSlice";

function App() {
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const theme = createTheme({
    typography: {
      fontFamily: ["IBM Plex Sans", "sans-serif"].join(","),
    },
  });

  // load library over here
  useEffect(() => {
    // Check the environment variable
    const isProduction = process.env.REACT_APP_SERVER === "production";

    if (isProduction) {
      const scriptElement = richSnippetImplementation();
      document.body.appendChild(scriptElement);
    }

    // Function to be executed on mouse movement
    const loadAllScripts = () => {
      // google tag manager
      // loadScriptByURL(
      //   "google-tag-manager",
      //   "https://www.googletagmanager.com/gtag/js?id=G-D41DPKNEN1",
      //   function () {
      //     return;
      //   }
      // );
      // google map api
      // loadScriptByURL(
      //   "google-map",
      //   `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`,
      //   function () {
      //     return;
      //   }
      // );
    };

    // Attach event listeners

    // document.addEventListener("mousemove", loadAllScripts);
    // document.addEventListener("click", loadAllScripts);

    // Clean up event listeners on component unmount
    return () => {
      // document.removeEventListener("mousemove", loadAllScripts);
      // document.removeEventListener("click", loadAllScripts);
    };
  }, []);

  // const loaded = useGoogleMapsScript(GOOGLE_API_KEY);

  const loadScript = (url, callback) => {
    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com/maps/api/js"]',
    );

    if (existingScript) {
      callback();
      return;
    }

    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.defer = true;
    script.onload = callback;
    document.head.appendChild(script);
  };

  const waitForPlacesLibrary = (callback, attempts = 50) => {
    if (window.google?.maps?.places) {
      callback();
      return;
    }

    if (attempts <= 0) {
      console.warn(
        "Google Places did not load. If autocomplete fails on servicer.localhost, add http://servicer.localhost:3000/* to your Google Maps API key HTTP referrers in Google Cloud Console.",
      );
      return;
    }

    window.setTimeout(() => waitForPlacesLibrary(callback, attempts - 1), 200);
  };

  useEffect(() => {
    // if (!shouldLoadGoogleMapsScript()) {
    //   return;
    // }

    loadScript(
      `https://maps.googleapis.com/maps/api/js?libraries=places&key=${GOOGLE_API_KEY}`,
      () => {
        waitForPlacesLibrary(() => {
          setLoaded(true);
          dispatch(autocompleteAction.changeLoadedStatus(true));
        });
      },
    );
  }, [dispatch]);

  // if (!loaded) return <Loader />;

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Elements stripe={stripePromise}>
          <RootRouter />
        </Elements>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
